import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import isPlainObject from 'lodash/isPlainObject';
import { ActionRunEnv } from '@/common/util/action-run-env';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
import { getRealResponse, makeRequest } from '@/common/util/request';
import { executeFunction, getArrayTableCurrentRowByField2, getRealizeValue, isRecursionComponent, } from '@/common/util/util';
export const getRequestButtonConfig = (optType) => {
    return {
        value: optType,
        position: ALL_BUTTON_POSITION_LIST,
        action: (config, extra) => {
            let { recordDataSource, extraParamList } = config;
            const { buttonConfig = {}, record, componentProps = {}, position, tableRef, state, urlParamsDataSource, needSuccessToast, arrayTableConfig, noNeedHandleResult, isDesign, _context, field, formInstance, actionRunEnv, getExtraParam, arrayTableCurrentRow, arrayBaseFieldIndex, parentComponentName, getFormInstance, } = config;
            const { options = {} } = buttonConfig;
            const { keepPagination } = options;
            if (ButtonPosition.formItemRightButton === position) {
                if (typeof getFormInstance === 'function') {
                    const _formValue = getFormInstance?.()?.values;
                    if (isPlainObject(_formValue)) {
                        recordDataSource = _formValue;
                    }
                }
            }
            else if (isRecursionComponent(parentComponentName)) {
                recordDataSource = getArrayTableCurrentRowByField2(field) || {};
                const segments = field?.path?.segments || [];
                extraParamList = segments[segments?.length - 2];
            }
            if (position === ButtonPosition.arraySubAreaCardOperate) {
                recordDataSource = arrayTableCurrentRow;
                extraParamList = [arrayBaseFieldIndex];
            }
            else if (position === ButtonPosition.arrayTableOperate) {
                if (extra?.field) {
                    const { field: _field } = extra;
                    const { formItemConfig } = arrayTableConfig || {};
                    if (formItemConfig?.name && _field) {
                        const list = _field?.query?.('..')?.value?.();
                        if (Array.isArray(list) && list[_field?.index]) {
                            recordDataSource = list[_field.index];
                            if (!extraParamList) {
                                extraParamList = [_field.index];
                            }
                        }
                    }
                }
            }
            const realField = field || extra?.field;
            return makeRequest({
                buttonConfig,
                urlParamsDataSource,
                recordDataSource: getRealizeValue(recordDataSource),
                state,
                needSuccessToast,
                noNeedHandleResult,
                extraParamList,
                position,
                isDesign,
                _context,
                getExtraParam: () => {
                    const tempExtraParam = executeFunction(getExtraParam);
                    let extraParam = {};
                    if (isPlainObject(tempExtraParam)) {
                        extraParam = {
                            ...tempExtraParam,
                        };
                    }
                    // const realFormInstance = getRealizeValue(formInstance);
                    // if(realFormInstance && field && position === ButtonPosition.formItemEvent) {
                    //   const tempFormValue = realFormInstance.values;
                    //   if(tempFormValue) {
                    //     const segments = field?.path?.segments;
                    //     if(isArrayNotEmpty(segments) && segments.length >= 3) {
                    //       const needSegments = segments.slice(0,2)
                    //       const tempCurrentRow = get(tempFormValue, needSegments)
                    //       if(isPlainObject(tempCurrentRow)) {
                    //         extraParam[__arrayTableCurrentRow__] = tempCurrentRow;
                    //       }
                    //     }
                    //
                    //   }
                    // }
                    const realFormInstance = getRealizeValue(formInstance);
                    if (realFormInstance &&
                        realField &&
                        [
                            ButtonPosition.formItemEvent,
                            ButtonPosition.arraySubAreaCardOperate,
                        ].includes(position)) {
                        const tempCurrentRow = realFormInstance?.getValuesIn?.(field?.path?.parent?.()?.segments);
                        if (isPlainObject(tempCurrentRow)) {
                            extraParam[__arrayTableCurrentRow__] = tempCurrentRow;
                        }
                    }
                    return extraParam;
                },
                handleParams: () => {
                    const params = {};
                    if (position === ButtonPosition.tableOperate) {
                        const { primaryKey } = componentProps;
                        if (primaryKey && record[primaryKey] !== undefined) {
                            params[primaryKey] = record[primaryKey];
                        }
                    }
                    return params;
                },
            }).then((res) => {
                if (position !== ButtonPosition.tableToolArea) {
                    if (actionRunEnv === ActionRunEnv.flowAction ||
                        actionRunEnv === 'pollingAction') {
                        /* empty */
                    }
                    else if (position === ButtonPosition.tableOperate) {
                        if (keepPagination === true) {
                            tableRef?.tableLoad()?.();
                        }
                        else {
                            tableRef?.load?.();
                        }
                    }
                    else {
                        tableRef?.load?.();
                    }
                }
                return res;
            });
        },
        handleFlowResult: (res) => {
            return getRealResponse(res);
        },
    };
};
export const config = getRequestButtonConfig('request');
